<template>
  <div class="cart-popup__dialog">
    <TripleEyeHeader />

    <!-- 01_check -->
    <div class="cart-popup__content height-auto" v-show="!isTest">
      <div class="content_eyecare">

        <div class="marB">
          <p class="eyecare_tit">
            <b class="color_orange">1. 나는 황반변성인가? </b>
          </p>
          <p class="eyecare_txt">
            황반변성이 진행되면 그전으로 되돌리는 것에 어려움이 있으므로 미리 확인하고 예방하는 것이 중요합니다.<br> 아래 그림을 통해 황반변성 자가 테스트를 해보세요.
          </p>
          <div class="eyecare_list color_black">
            <ul>
              <li>&middot; 안경을 사용하시는 경우 착용하세요.</li>
              <li>&middot; 약 30cm 떨어진 상태에서 격자 무늬를 보세요.</li>
              <li>&middot; 한 눈 씩 가리고 중심에 있는 검은 점을 보세요.</li>
              <li>&middot; 검은 점을 보면서 주변의 선들이 곧게 보이는지 확인하세요.</li>
            </ul>
          </div>
          <div class="txtC marB padT"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/eyecare/02_cont_01.png" alt="네모 격자 무늬, 가운데 가로 세로 굵은 선이 있고, 만나는 곳에 점이 있음" style="max-width:400px;width:100%"></div>
          <p class="eyecare_comment">
            출처: 한국망막학회<br>
            “본 자가진단은 증상의 조기발견을 도와 주기 위한 것으로,
            정확한 진단을 위해서는 의사와 상담이 필요합니다.”
          </p>
        </div>
        <p style="color:#aaa;font-size:9px;text-align:right">CN001953</p>
      </div>
    </div>
    <div class="cart-popup__item-link" v-show="!isTest">
      <button type="button" class="bt-akl-blue bt-eyecare-pop-orange" @click="isTest = true">결과보기</button>
    </div>
    <!-- //01_check -->

    <!-- 01_result -->
    <div class="cart-popup__content height-auto" v-show="isTest">
      <div class="content_eyecare">

        <div class="marB">
          <p class="eyecare_tit">
            <b class="color_orange">1. 나는 황반변성인가? </b>
          </p>
          <p class="eyecare_txt color_black">만약!</p>
          <div class="eyecare_list">
            <ul>
              <li><b>- 가운데 점이 잘 보이지 않거나</b></li>
              <li><b>- 선들이 휘어 보이고 끊어져 보이거나</b></li>
              <li><b>- 안보이는 부분이 있으시면</b></li>
            </ul>
          </div>
          <p class="eyecare_txt2">
            <b class="color_red">황반변성을 의심</b>해 볼 수 있습니다.<br> 이때는 빨리 병원을 찾아 정확한 검사를 받아보세요.
          </p>
          <div class="txtC marB padT"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/eyecare/03_cont_01.png" alt="정상인 경우(네모 격자 무늬, 가운데 가로 세로 굵은 선이 있고, 만나는 곳에 점이 있음 : 그대로 보임), 황반변성 이상증상(네모 격자 무늬, 가운데 가로 세로 굵은 선이 있고, 만나는 곳에 점이 있음 : 일부분이 찌그러지고 그 중심 부분이 멍들어 보임)"></div>
          <p class="eyecare_comment">
            출처: 한국망막학회<br>
            “본 자가진단은 증상의 조기발견을 도와 주기 위한 것으로,
            정확한 진단을 위해서는 의사와 상담이 필요합니다.”
          </p>
        </div>
        <p style="color:#ccc;font-size:9px;text-align:right">CN001953</p>
      </div>
    </div>
    <div class="cart-popup__item-link" v-show="isTest">
      <button type="button" class="bt-akl-blue bt-eyecare-pop-orange" @click="$emit('clickNext')">다음으로</button>
    </div>
    <!-- //01_result -->

  </div>
</template>

<script>
import TripleEyeHeader from './header.vue'

export default {
  name: 'TripleQuest1',
  components: {
    TripleEyeHeader
  },
  data () {
    return {
      isTest: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/triple-eye-care/component/quest1.vue